import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import quoteCamIcon from '../assets/quotecam-icon.png';
import { trackPageView } from '../utils/analytics';

const QuoteCamPrivacy = () => {
  useEffect(() => {
    trackPageView('QuoteCam Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={quoteCamIcon} alt="QuoteCam" />
          </div>
          <div className="app-details">
            <h1>QuoteCam</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>QuoteCam does not collect, store, sell, or transmit personal information, usage data, or analytics. We do not operate servers that receive your photos, scans, quotations, or library content.</p>
        </div>

        <div className="privacy-section">
          <h2>Camera and Text Recognition</h2>
          <p>QuoteCam uses the camera only when you choose to scan text. Text recognition and image processing are performed on your device using Apple system frameworks. Camera images and recognized text are not sent to us.</p>
        </div>

        <div className="privacy-section">
          <h2>Local Storage</h2>
          <p>Your saved quotations, images, app preferences, language settings, and appearance settings are stored locally on your device. Removing the app may remove this locally stored content unless it has been saved or shared elsewhere by you.</p>
        </div>

        <div className="privacy-section">
          <h2>Sharing</h2>
          <p>QuoteCam lets you share content through the iOS share sheet. Sharing occurs only after you initiate it and select a destination. Any service you choose may process the shared content under its own privacy policy.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>QuoteCam does not include advertising networks, third-party analytics SDKs, or tracking technologies.</p>
        </div>

        <div className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>QuoteCam does not knowingly collect personal information from children or any other users.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> August 22, 2026</p>
        </div>
      </main>
    </div>
  );
};

export default QuoteCamPrivacy;
